module.exports = __webpack_public_path__ + "static/media/neutro-homes.7e7c6ca8.png";